import React from 'react';

import ScrollAnimation from 'react-animate-on-scroll';

import LinkButton from '@core/components/linkbutton/LinkButton';


import classes from './Hero.module.scss';


const Hero = () => {
    return (
        <>
            <div className={`container ${classes['wrapper']}`}>
                <div className={`${classes['hero-container']} d-flex flex-column justify-content-center align-items-center`}>
                    <h1>
                        Accelerate Your Pharma Career with Expert-Led Courses at
                        {/* <span className={classes["sign"]}>
                        <span className={classes["fast-flicker"]}>P</span><span className={classes["slow-flicker"]}>har</span><span className={classes["flicker"]}>m</span><span className={classes["meduim-flicker"]}>uni</span>
                    </span> */}
                        {/* <span title="Pharmuni" className={classes['anim']}>Pharmuni</span> */}
                        {/* <span className={classes["wrapper"]}>
                        PHARMUNI
                    </span> */}
                        <div className={classes['pharmuni-name']}>
                            <ScrollAnimation animateIn="fadeIn" duration={0.2} >
                                P
                            </ScrollAnimation>
                            <ScrollAnimation animateIn="fadeIn" duration={0.2} delay={150}>
                                h
                            </ScrollAnimation>
                            <ScrollAnimation animateIn="fadeIn" duration={0.2} delay={300}>
                                a
                            </ScrollAnimation>
                            <ScrollAnimation animateIn="fadeIn" duration={0.2} delay={450}>
                                r
                            </ScrollAnimation>
                            <ScrollAnimation animateIn="fadeIn" duration={0.2} delay={600}>
                                m
                            </ScrollAnimation>
                            <ScrollAnimation animateIn="fadeIn" duration={0.2} delay={750}>
                                u
                            </ScrollAnimation>
                            <ScrollAnimation animateIn="fadeIn" duration={0.2} delay={900}>
                                n
                            </ScrollAnimation>
                            <ScrollAnimation animateIn="fadeIn" duration={0.2} delay={1050}>
                                i
                            </ScrollAnimation>
                        </div>
                    </h1>

                    <p>
                        Master and earn certificates in GMP, Pharmacovigilance, and Quality Management through 40+ specialized programs—developed by Zamann Pharma Support (TÜV ISO 9001) and aligned with 800+ real pharma job requirements.
                    </p>
                    <div className='d-flex flex-wrap align-items-center justify-content-center gap-2 my-4'>
                        <LinkButton
                            kind='primary-light'
                            to={'/explore'}
                        >
                            Explore 40+ Pharma Courses
                        </LinkButton>
                        <LinkButton
                            kind='primary-color'
                            to={'/get-started'}
                        >
                            Join for Free
                        </LinkButton>
                    </div>

                </div>
                <script async src={'animation.js'}></script>                
            </div>
            
        </>
    );
};

export default Hero;